import { Area } from "../entities/Area";
import { ProductLeg } from "../entities/ProductLeg";

const MULTIPLIER = 1000;

const snapToGrid = (value: number, resolution: number, strategy: 'round-up' | 'round-down' = 'round-down') => {
	const val = value * MULTIPLIER;
	const res = resolution * MULTIPLIER;
	const roundFn = strategy === 'round-up' ? Math.ceil : Math.floor;

	return (roundFn(val/res) * res) / MULTIPLIER;
}

export const snapAreaToGrid = (a: Area, resolution: number): Area => {
	return {
		north: snapToGrid(a.north, resolution),
		south: snapToGrid(a.south, resolution, 'round-up'),
		east: snapToGrid(a.east, resolution),
		west: snapToGrid(a.west, resolution, 'round-up')
	};
};

export const findFinestGrid = (legs: Map<number, ProductLeg>) => {
	const finest = Math.min(
		...Array.from(legs.values())
			.filter(l => l.grid?.value !== undefined)
			.map(l => l.grid!.value!)
	);

	return isFinite(finest) ? finest : undefined;
};
